module.exports = __webpack_public_path__ + "img/5.938ac77d.jpg";